import { NgModule } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { CartCreationDialogComponent } from './cart-creation-dialog.component';
import { MonthToStringPipe } from 'projects/shared/lib/pipes/time/month-to-string-pipe/month-to-string.pipe';
import { EDayOfWeekToStringPipe } from 'projects/shared/lib/pipes/time/eday-of-week-to-string-pipe/eday-of-week-to-string.pipe';
import { CalendarDayModule } from '../../calendar/calendar-day/calendar-day.module';
import { AddressDetailComponent } from 'projects/shared/lib/components/shared/address/detail/address-detail.component';


@NgModule({
  declarations: [
    CartCreationDialogComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,

    MonthToStringPipe,
    EDayOfWeekToStringPipe,
    CalendarDayModule,
    AddressDetailComponent,
  ],
  exports: [
    CartCreationDialogComponent,
  ],
  providers: [
    DatePipe,
  ]
})
export class CartCreationDialogModule { }
